const InvisiblePermissions = {
  USER: {
    VERIFIED: 'user.verified',
    HAS_CLIENT: 'user.has_client',
  },
};

export default InvisiblePermissions;
